import React from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../state";
import TreeCard from "../../../../../atoms/ActiveLearning/TreeCard";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson5/Material/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson5/Material/Issue2";
import Issue3 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson5/Material/Issue3";
import styles from "../../ActiveLearningLesson.module.scss";
import SaveAnswerButton from "../../../../../atoms/ActiveLearning/SaveAnswerButton";

type Lesson5MaterialProps = {
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

const lastAnswers = ["問題", "原因", "理想状況", "課題"];

export const Lesson5Material = (props: Lesson5MaterialProps) => {
  return (
    <>
      <div className={styles.section}>
        <div className={styles.review}>
          <p className={styles.title}>前回の振り返り</p>
          <div className={styles.tree}>
            <TreeCard title={"問い"} text={"回答データがありません。"} />
            <ul className={styles.branchList}>
              {lastAnswers.map((lastAnswer, index) => (
                <li key={index} className={styles.branch}>
                  <div className={styles.labelWrapper}>
                    <span className={styles.label}>{lastAnswer}</span>
                  </div>
                  <ul className={styles.answerList}>
                    <li className={clsx(styles.answer, styles.single)}>
                      回答データがありません。
                    </li>
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.section}>
        <Issue1 issue={props.findIssue && props.findIssue(1)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue2 issue={props.findIssue && props.findIssue(2)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue3 issue={props.findIssue && props.findIssue(3)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
    </>
  );
};
export default Lesson5Material;
